import React from 'react';
import { User, Bell, Users, Plane } from 'lucide-react';
import { getUserRole } from '../lib/auth';

interface NavigationProps {
  currentPath: string;
}

export function Navigation({ currentPath }: NavigationProps) {
  const [isAdmin, setIsAdmin] = React.useState(false);

  React.useEffect(() => {
    const checkRole = async () => {
      const role = await getUserRole();
      setIsAdmin(role === 'admin');
    };
    checkRole();
  }, []);

  const handleNavigation = (path: string) => {
    window.location.hash = path.replace('/', '');
  };

  if (isAdmin) {
    return null;
  }

  return (
    <>
      {/* Mobile Navigation - Bottom */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
        <div className="grid grid-cols-4 gap-1">
          <button 
            onClick={() => handleNavigation('/profile')}
            className={`flex flex-col items-center py-3 px-2 ${
              currentPath === '/profile'
                ? 'text-blue-600'
                : 'text-gray-600'
            }`}
          >
            <User size={24} className="mb-1" />
            <span className="text-xs">Perfil</span>
          </button>

          <button
            onClick={() => handleNavigation('/alerts')}
            className={`flex flex-col items-center py-3 px-2 ${
              currentPath === '/alerts'
                ? 'text-blue-600'
                : 'text-gray-600'
            }`}
          >
            <Bell size={24} className="mb-1" />
            <span className="text-xs">Alertas</span>
          </button>

          <button
            onClick={() => handleNavigation('/referrals')}
            className={`flex flex-col items-center py-3 px-2 ${
              currentPath === '/referrals'
                ? 'text-blue-600'
                : 'text-gray-600'
            }`}
          >
            <Users size={24} className="mb-1" />
            <span className="text-xs">Indicações</span>
          </button>
        </div>
      </nav>

      {/* Desktop Navigation - Top */}
      <nav className="hidden md:block fixed top-16 left-0 right-0 bg-white border-b border-gray-200 z-40">
        <div className="max-w-4xl mx-auto px-4 py-2">
          <div className="flex gap-2">
            <button 
              onClick={() => handleNavigation('/profile')}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${
                currentPath === '/profile'
                  ? 'bg-blue-100 text-blue-700'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <User size={20} />
              <span>Meu Perfil</span>
            </button>

            <button
              onClick={() => handleNavigation('/alerts')}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${
                currentPath === '/alerts'
                  ? 'bg-blue-100 text-blue-700'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <Bell size={20} />
              <span>Alertas</span>
            </button>

            <button
              onClick={() => handleNavigation('/flights')}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${
                currentPath === '/flights'
                  ? 'bg-blue-100 text-blue-700'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <Plane size={20} />
              <span>Passagens</span>
            </button>

            <button
              onClick={() => handleNavigation('/referrals')}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-colors ${
                currentPath === '/referrals'
                  ? 'bg-blue-100 text-blue-700'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <Users size={20} />
              <span>Indicações</span>
            </button>
          </div>
        </div>
      </nav>
    </>
  );
}